import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    import(/* webpackChunkName: "home" */ "../views/Home.vue")
  },
  {
    path: "/heroes",
    name: "Heroes",
    component: () =>
    import(/* webpackChunkName: "heroes" */ "../views/Heroes.vue")
  },
  {
    path: "/masterminds",
    name: "Masterminds",
    component: () =>
    import(/* webpackChunkName: "masterminds" */ "../views/Masterminds.vue")
  },
  {
    path: "/villains",
    name: "Villains",
    component: () =>
    import(/* webpackChunkName: "villains" */ "../views/Villains.vue")
  },
  {
    path: "/henchmen",
    name: "Henchmen",
    component: () =>
    import(/* webpackChunkName: "henchmen" */ "../views/Henchmen.vue")
  },
  {
    path: "/schemes",
    name: "Schemes",
    component: () =>
    import(/* webpackChunkName: "schemes" */ "../views/Schemes.vue")
  },
  {
    path: "/bystanders",
    name: "Bystanders",
    component: () =>
    import(/* webpackChunkName: "bystanders" */ "../views/Bystanders.vue")
  },
  {
    path: "/wounds",
    name: "Wounds",
    component: () =>
    import(/* webpackChunkName: "wounds" */ "../views/Wounds.vue")
  },
  {
    path: "/officers",
    name: "Officers",
    component: () =>
    import(/* webpackChunkName: "officers" */ "../views/Officers.vue")
  },
  {
    path: "/sidekicks",
    name: "Sidekicks",
    component: () =>
    import(/* webpackChunkName: "sidekicks" */ "../views/Sidekicks.vue")
  },
  {
    path: "/random",
    name: "Random",
    component: () =>
    import(/* webpackChunkName: "random" */ "../views/Random.vue")
  },
  {
    path: "/setup",
    name: "Setup",
    component: () =>
    import(/* webpackChunkName: "game-setup" */ "../views/Setup.vue")
  },
  {
    path: "/solo",
    name: "Solo (Alpha)",
    component: () =>
    import(/* webpackChunkName: "play-solo" */ "../views/PlaySolo.vue")
  },
  {
    path: "/keywords",
    name: "Keywords",
    component: () =>
    import(/* webpackChunkName: "keywords" */ "../views/Keywords.vue")
  },
  {
    path: "/about",
    name: "About",
    component: () =>
    import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/csearch",
    name: "Card Search",
    component: () =>
    import(/* webpackChunkName: "search" */ "../views/CardSearch.vue")
  },
  {
    path: "/cbrowser",
    name: "Card Browser",
    component: () =>
    import(/* webpackChunkName: "browser" */ "../views/CardBrowser.vue")
  },
  {
    path: "/rsearch",
    name: "Rule Search",
    component: () =>
    import(/* webpackChunkName: "search" */ "../views/RuleSearch.vue")
  },
  {
    path: "*",
    name: "Fallback",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
});

export default router;
